import EventEmitter from "./EventEmitter"
import * as THREE from "three"
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js"




export default class Resources extends EventEmitter
{
    constructor(sources)
    {
        super()

        //Options
        this.sources = sources
        

        //Setup
        this.items = {}
        this.toLoad = this.sources.length
        this.loaded = 0

        this.setLoaders()
        this.startLoading()
    }

    setLoaders()
    {
        this.loaders = {}
        this.loaders.gltfLoader = new GLTFLoader()
        this.loaders.textureLoader = new THREE.TextureLoader()
        this.loaders.cubeTextureLoader = new THREE.CubeTextureLoader()
    }

    startLoading()
    {
        // Load each sources
        for(const sources of this.sources)
        {
            if(sources.type === 'gltfModel')
            {
                this.loaders.gltfLoader.load(
                    sources.path,
                    (file) =>
                    {
                        this.sourceLoaded(sources, file)
                    }
                )
            }
            else if(sources.type === 'texture')
                {
                    this.loaders.textureLoader.load(
                        sources.path,
                        (file) =>
                            {
                                this.sourceLoaded(sources, file)
                            }
                        )
            }
            else if(sources.type === 'cubeTexture')
                {
                    this.loaders.cubeTextureLoader.load(
                        sources.path,
                        (file) =>
                        {
                            this.sourceLoaded(sources, file)
                        },
                    )
                }
        }
    }

    sourceLoaded(sources, file)
    {
        this.items[sources.name] = file
        this.loaded++

        if(this.loaded === this.toLoad)
        {
            this.trigger('ready')
        }
    }
}